import React, { useEffect, useState } from 'react';
import TextfieldInput from '../../Shared/TextField';
import { dataService } from '../../../Services/data/data.service';
import { Select, MenuItem, Grid2, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import { Save } from 'lucide-react';
import Button from '../../Shared/Buttons/Button';
import HeaderBar from '../../Shared/Header/HeaderBar';
import HeaderTitle from '../../Shared/Header/HeaderTitle';
import Breadcrumb from '../../Shared/Header/Breadcrumb';
import TableList from './Components/TableCreateList';
import CustomCheckbox from '../../Shared/Checkbox';
import 'react-toastify/dist/ReactToastify.css';

function CreateListPage(props) {

    const classes = useStyles();
    const navigate = useNavigate();

    const [listName, setListName] = useState("");
    const [listCompany, setListCompany] = useState(null);
    const [allUserCompanies, setAllUserCompanies] = useState([]);
    const [listDescription, setListDescription] = useState("");

    const [helperTextListName, setHelperTextListName] = useState(null);
    const [helperTextListCompany, setHelperTextListCompany] = useState(null);
    const [helperTextListDescription, setHelperTextListDescription] = useState(null);

    const [errorListName, setErrorListName] = useState(false);
    const [errorListCompany, setErrorListCompany] = useState(false);

    const [emptyDetails, setEmptyDetails] = useState(false);
    const [listItems, setListItems] = useState([]);
    var today = new Date();

    const [isMultiSelect, setIsMultiSelect] = useState(false);

    useEffect(() => {
    }, [props.Login.userid]);

    const setList = (event) => {
        setListName(event.target.value);
    }

    const setDescription = (event) => {
        setListDescription(event.target.value);
    }

    useEffect(() => {
        dataService.getAllCompaniesByUserId(props.Login.userid).then(results => {
            setAllUserCompanies(results);
        })
    }, [props.Login.userid])

    const validate = () => {
        let errors = 0;

        // Name
        if (listName.trim() === "" || !listName) {
            errors++;
            setHelperTextListName("Please enter a dropdown name.")
            setErrorListName(true)
        } else if (listName.trim().length > 50) {
            errors++;
            setHelperTextListName("Name can not be longer than 50 characters")
            setErrorListName(true)
        } else {
            setHelperTextListName("")
            setErrorListName(false)
        }

        // Description
        if (listDescription.trim().length > 1000) {
            errors++;
            setHelperTextListDescription("Description can not be longer than 1000 characters")
        } else {
            setHelperTextListDescription("");
        }

        // Company
        if (!listCompany) {
            errors++;
            setHelperTextListCompany("Please select a company")
            setErrorListCompany(true);
        } else {
            setHelperTextListCompany("")
            setErrorListCompany(false);
        }


        if (errors > 0) {
            return false;
        } else {
            return true;
        }
    }

    const sendToApi = () => {
        if (validate()) {
            setEmptyDetails(false)
            if (listItems.length === 0 || listItems[0].itemName === "") {
                setEmptyDetails(true)
            }
            else if (listItems[listItems.findIndex(x => x.itemName === "")]) {
                let DataListItemsToRemove = [...listItems];
                let RemoveObjectId = DataListItemsToRemove[DataListItemsToRemove.findIndex(x => x.itemName === "")].Id;
                DataListItemsToRemove.splice(RemoveObjectId - 1, 1);
                let userid = props.Login.userid
                let DataListItems = DataListItemsToRemove.map(x => ({ Id: x.Id, Name: x.itemName, Description: x.itemDescription, InsertedOn: x.InsertedOn, InsertedByUserId: x.userid }));
                dataService.createNewDataList(listName, listCompany.id, listDescription, isMultiSelect, today, userid, DataListItems).then(results => {
                    navigate(`/modifydropdown/${results.uniqueId}`);
                })

            }
            else {
                // API CALL HERE
                let userid = props.Login.userid
                let DataListItems = listItems.map(x => ({ Id: x.Id, Name: x.itemName, Description: x.itemDescription, InsertedOn: x.InsertedOn, InsertedByUserId: x.userid }));
                dataService.createNewDataList(listName, listCompany.id, listDescription, isMultiSelect, today, userid, DataListItems).then(results => {
                    navigate(`/modifydropdown/${results.uniqueId}`);
                })
            }
        }
    }

    return (
        <React.Fragment>
            <Box className="page-container">
                <HeaderBar>
                    <Breadcrumb onClick={() => navigate('/dropdownoverview')}>Dropdowns</Breadcrumb>
                    <HeaderTitle>Create a new dropdown</HeaderTitle>
                </HeaderBar>

                <Box className={classes.container}>
                    <Box className={classes.projectSelectionContainer}>
                        <div className={classes.formContainer}>
                            <div className={classes.formColumn}>
                                <div className={classes.projectOption}>
                                    <div className={classes.projectOption__labelContainer}>
                                        {!helperTextListName ?
                                            <p className={classes.labelContainer__label}>Name of your dropdown</p>
                                            :
                                            <p className={classes.labelContainer__helperText}>{helperTextListName}</p>
                                        }
                                    </div>
                                    <div className={classes.projectOption__inputContainer}>
                                        <TextfieldInput value={listName} action={setList} label={listName ? " " : "Dropdown"} InputLabelProps={{ shrink: false }} error={errorListName} />
                                    </div>
                                </div>
                                <div className={classes.projectOption}>
                                    <div className={classes.projectOption__labelContainer}>
                                        {!helperTextListCompany ?
                                            <p className={classes.labelContainer__label}>Select a company</p>
                                            :
                                            <p className={classes.labelContainer__helperText}>{helperTextListCompany}</p>
                                        }
                                    </div>
                                    <div className={classes.projectOption__inputContainer}>
                                        <Select
                                            value={listCompany}
                                            onChange={(e) => setListCompany(e.target.value)}
                                            displayEmpty
                                            error={errorListCompany}
                                            style={{ width: "100%" }}
                                            renderValue={listCompany !== "" ? undefined : () => "Company"}
                                        >
                                            {/* If no company is selected, this is a placeholder */}
                                            {allUserCompanies.length < 1 &&
                                                <MenuItem value="">
                                                    <em>You are not part of a company</em>
                                                </MenuItem>
                                            }
                                            {/* Populate the dropdown with companies from allUserCompanies */}
                                            {allUserCompanies.map((company, index) => (
                                                <MenuItem key={index} value={company}>
                                                    {company.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className={classes.projectOption__checkboxContainer}>
                                        <CustomCheckbox label="Multi-select List" checked={isMultiSelect} onChange={setIsMultiSelect} indeterminate={false} disabled={false} />
                                    </div>
                                </div>
                            </div>
                            <div className={classes.listDescriptionStyle}>
                                <div className={classes.projectOption__labelContainer}>
                                    {!helperTextListDescription ?
                                        <p className={classes.labelContainer__label}>Description of your dropdown</p>
                                        :
                                        <p className={classes.labelContainer__helperText}>{helperTextListDescription}</p>
                                    }
                                </div>
                                <textarea className={classes.description__textarea} value={listDescription} onChange={(e) => setDescription(e)}></textarea>
                                {/* <TextfieldInput rows={3} multiline error={errorListDescription} value={listDescription} action={setDescription} label={listDescription ? " " : "Description"} InputLabelProps={{ shrink: false }} /> */}
                            </div>
                        </div>
                    </Box>
                    {emptyDetails === true ?
                        <div>
                            <Grid2 item xs={12} sm={12} md={12} style={{ border: "solid 2px", borderColor: "#d32f2f", borderRadius: "17px" }}>
                                <TableList {...props} rows={listItems} setRows={setListItems} makeSave={sendToApi} />
                            </Grid2>
                            <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em" }}>Please create at least one item.</p>
                        </div>
                        :
                        <div>
                            <Grid2 item xs={12} sm={12} md={12}>
                                <TableList {...props} rows={listItems} setRows={setListItems} />
                            </Grid2>
                        </div>}
                    <div className={classes.buttonContainer}>
                        <Button startIcon={<Save />} onClick={sendToApi}>
                            Save
                        </Button>
                    </div>
                </Box>
            </Box>
        </React.Fragment >
    )
}

export default CreateListPage;
const useStyles = makeStyles((theme) => ({
    linkButton: {
        color: 'white !important',
        background: "var(--color-primary) !important",
        border: "1px solid var(--color-primary) !important",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: '0.3s',
        "&:hover": {
            background: "rgba(195, 153, 107, 0.85) !important",

        },
    },

    buttonContainer: {
        marginTop: '15px',
        display: 'flex',
        alignItems: 'center',
        float: 'right'

    },

    description__textarea: {
        height: "100%",
        width: "100%",
        boxSizing: "border-box",
        padding: "8px",
        fontFamily: "Lato, sans-serif",
        fontSize: "16px",
        backgroundColor: "transparent",
        border: "1px solid #BDBDBD",
        borderRadius: "4px",
        resize: "none",

        [theme.breakpoints.down('sm')]: {
            height: "120px",
        },
    },

    projectOption: {
        minWidth: "240px",
        maxWidth: "100%",

        display: "flex",
        flexDirection: "column",
        gap: "4px",
    },

    projectSelectionContainer: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        boxSizing: "border-box",
        borderRadius: "8px",
        marginBottom: "16px",
        padding: "16px",
    },

    projectOption__labelContainer: {
        display: "flex",
        gap: "8px",
    },

    labelContainer__label: {
        fontSize: "16px",
        color: "rgb(105, 105, 105)",
        margin: "0px",
    },

    labelContainer__helperText: {
        fontSize: "15px",
        color: "red"
    },

    projectOption__checkboxContainer: {
        height: "56px",
        width: "100%",

        display: "flex",
        alignItems: "center",

        padding: "0px 12px",
        marginTop: "8px",

        borderRadius: "4px",
        border: "1px solid #adb5bd",

    },

    listDescriptionStyle: {
        width: '100%',

        display: "flex",
        flexDirection: "column",
        gap: "4px",
    },

    primaryIconButton: {
        height: "40px",
        padding: "0 16px",
        paddingLeft: "8px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "var(--color-primary)",

        display: "flex",
        gap: "8px",
        alignItems: "center",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            cursor: "pointer",
        }
    },

    iconButton__icon: {
        height: "20px",
        width: "20px",

        display: "block",
    },

    formContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        gap: "16px",

        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
            gap: "8px",
        },
    },

    formColumn: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },
}));